import {
  Component,
  OnInit,
  HostListener,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { TokenService } from "../../../core/tokenManagement/token.service";
import { SharedService } from "../../services/shared.service";
import "rxjs/add/operator/pairwise";
import { Router } from "@angular/router";

@Component({
  selector: "app-side-nav",
  templateUrl: "./side-nav.component.html",
  styleUrls: ["./side-nav.component.css"],
})
export class SideNavComponent implements OnInit {
  perms = this.sharedservice.permissions;
  @Input() status;
  @Output() sideNavStatus: EventEmitter<boolean> = new EventEmitter();
  menuContent = {
    dashboard: true,
    product: false,
    transaction: false,
    settlement: false,
    settings: false,
    howto:false
  };

  constructor(
    private tokenservice: TokenService,
    private sharedservice: SharedService,
    private router: Router
  ) {}

  ngOnInit() {
    this.sharedservice.activatePermmisions();
    this.router.events.subscribe((val) => {});
  }

  navigate(){
    this.router.navigate(['/how-to']);
    this.onRouteChange('howto');

  }

  ngOnChanges() {
    if ((this.status = false && window.innerWidth <= 800)) {
      this.closeNavCompletelyOnSmallScreen();
    } else {
      this.openNav();
    }
  }

  //use to control image change on the side menu.. we are not using route event lister here
  onRouteChange(e) {
    let valueHolder = Object.keys(this.menuContent);
    for (let key in this.menuContent) {
      if (key == e) {
        this.menuContent[key] = true;
      } else {
        this.menuContent[key] = false;
      }
    }
  }

  setPermissions() {}

  checkandclose() {
    if (window.innerWidth <= 800) {
      this.closeNavCompletelyOnSmallScreen();
      this.sideNavStatus.emit(false);
      // this.closeNavCompletelyOnSmallScreen();
    }
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    if (event.target.innerWidth > 800) {
      document.getElementById("toggler").style.display = "block";
      document.getElementById("toggler").style.display = "block";
    } else {
      document.getElementById("toggler").style.display = "none";
      document.getElementById("toggler").style.display = "none";
    }
  }

  openNav() {
    if (window.innerWidth <= 800) {
      document.getElementById("toggler").style.display = "none";
      document.getElementById("toggler").style.display = "none";
    }
    // document.getElementById('toggler').style.transition = 'left ease-in 0.4s';
    document.getElementById("mySidebar").style.width = "250px";
    document.getElementById("main").style.marginLeft = "250px";
    document.getElementById("forward").style.display = "none";
    document.getElementById("toggler").style.left = "-3rem";
    document.getElementById("mySidebar").style.transition =
      "0.3s ease-in-out all";
    document.getElementById("toggler").style.transition =
      "0.01s ease-in-out all";

    document.getElementById("toggler").style.background =
      "#ffffff url('../../../../assets/icons/collapse-menu-icon.svg') no-repeat center";
    //document.getElementById('menu_list').style.transition = 'ease-in 8s';
    document.getElementById("menu_list").style.display = "flex";
    document.getElementById("sidebar_logo").style.display = "flex";
    document.getElementById("backward").style.display = "block";
  }

  closeNav() {
    document.getElementById("mySidebar").style.width = "3rem";
    document.getElementById("toggler").style.left = "-4rem";
    document.getElementById("toggler").style.background =
      "#ffffff url('../../../../assets/icons/open-menu-icon.svg') no-repeat center";
    document.getElementById("main").style.marginLeft = "4rem";
    document.getElementById("backward").style.display = "none";
    document.getElementById("forward").style.display = "block";
    document.getElementById("mySidebar").style.transition =
      "0.2s ease-in-out all";
    document.getElementById("toggler").style.transition =
      "0.01s ease-in-out all";
  }

  closeNavCompletelyOnSmallScreen() {
    document.getElementById("mySidebar").style.width = "0rem";
    document.getElementById("toggler").style.display = "none";
    document.getElementById("toggler").style.display = "none";
    document.getElementById("main").style.marginLeft = "0rem";
    document.getElementById("backward").style.display = "none";
    document.getElementById("forward").style.display = "none";
    document.getElementById("mySidebar").style.transition =
      "0.2s ease-in-out all";
    document.getElementById("toggler").style.transition =
      "0.01s ease-in-out all";
  }
}
